import logoColorAsset from '../assets/Logo-horizontal-colorida.png'
import logoWhiteAsset from '../assets/Logo-minimalista-branca.png'
import sidebarTopLogoCollapsedUrl from '../assets/Logo-minimalista-branca.png'

export const LOGO_URL = logoColorAsset
export const LOGO_URL_WHITE = logoWhiteAsset
export const LOGO_URL_WHITE_NO_LABEL = logoWhiteAsset
export const SIDEBAR_TOP_LOGO_COLLAPSED_URL = sidebarTopLogoCollapsedUrl
